<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-align-center bottom-0 left-0 right-0 top-0 !flex">
        <div
            class="flex-column flex h-auto w-full rounded-2xl bg-white dark:border-2 dark:border-solid dark:border-contrast-yellow">
            <div class="flex-align-center !flex justify-end border-b border-solid p-4">
                <p class="align-center absolute left-0 w-full flex-1 font-semibold">
                    {{ 'SAVE_FAVORITE_STOP' | translate }}
                </p>
                <button
                    class="text-grey-zambezy"
                    [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                    (click)="cancel()"
                    mat-icon-button>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="m-4">
                <ng-container>
                    <div class="flex-align-center mb-4 flex h-14 gap-4">
                        <ion-icon
                            class="vl-app-light:text-black h-7 w-7 text-secondary dark:text-contrast-yellow"
                            [src]="
                                (assetsPath$ | async) +
                                (env.EXPLORE?.USE_CONTRAST_ICON && (isContrast$ | async)
                                    ? '/img/explore/bus-contrast.svg'
                                    : '/img/explore/bus.svg')
                            "
                            aria-hidden="true"></ion-icon>
                        <p class="flex-1">
                            {{ stop.name }}
                            <span *ngIf="stop?.desc && env.EXPLORE?.SHOW_MUNICIPALITY_IN_STOP_NAME"
                                >({{ stop.desc }})</span
                            >
                        </p>
                    </div>
                    <div class="flex">
                        <button
                            class="vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black var-app-light:text-primary orb-app-light:bg-primary orb-app-light:text-black orb-app-light:font-semibold h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                            (click)="saveFavorite()"
                            type="submit">
                            {{ 'SAVE_FAVORITE' | translate }}
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
